import React from 'react';
import AdvertisementPaymentCompleteContainer from 'containers/AdvertisementPaymentCompleteContainer';

export default function AdvertisementPaymentCompletePage() {
  return <AdvertisementPaymentCompleteContainer />;
}
